

export { FilterEditor } from './src/index';
